// import React, { useState, useRef, useEffect } from "react";
// import { Menu, X, ChevronDown, LogOut, User2 } from "lucide-react";
// import { FaWallet } from "react-icons/fa";
// import { useNavigate } from "react-router-dom";
// import { useDispatch, useSelector } from "react-redux";
// import { logout, toggle } from "../Store/Slices/AuthSlice";
// import bingopayLogo from "../Assets/Images/logo_png_with_shreebalajee (1).png";
// import { FiEye, FiEyeOff } from "react-icons/fi";
// import {
//   fetchWalletBalance,
//   fetchAepsBalance,
//   fetchLienBalance,
//   fetchSettlementBalance,
// } from "../Store/Slices/WalletSlice";
// import { FiRefreshCcw } from "react-icons/fi";

// const BalanceBox = ({ label, value, loading }) => (
//   <div className="bg-white rounded-xl px-4 py-2 border border-slate-200 shadow-sm min-w-[90px]">
//     <p className="text-[11px] text-slate-500 font-medium">
//       {label} Balance
//     </p>
//     <p className="text-sm font-bold text-emerald-700">
//       ₹ {loading ? "…" : Number(value || 0).toFixed(2)}
//     </p>
//   </div>
// );

// const Navbar = () => {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const dropdownRef = useRef(null);

//   const [open, setOpen] = useState(false);
//   const [showBalance, setShowBalance] = useState(true);

//   const navOpen = useSelector((s) => s.auth.nav);
//   const role = useSelector((s) => s.auth.employeeDetails?.role);
//   const username = useSelector((s) => s.auth.employeeDetails?.username);

//   const { balance, aepsBalance, lienBalance, loading, settlementBalance } = useSelector(
//     (s) => s.wallet
//   );

//   // ===== INITIAL SIDEBAR STATE =====
//   useEffect(() => {
//     if (window.innerWidth >= 768) {
//       dispatch(toggle(true)); // desktop open
//     } else {
//       dispatch(toggle(false)); // mobile close
//     }
//   }, [dispatch]);

//   // ===== FETCH BALANCE =====
//   useEffect(() => {
//     dispatch(fetchWalletBalance());
//     dispatch(fetchAepsBalance());
//     dispatch(fetchSettlementBalance());
//   }, [dispatch]);

//   // ===== CLOSE DROPDOWN =====
//   useEffect(() => {
//     const close = (e) =>
//       dropdownRef.current &&
//       !dropdownRef.current.contains(e.target) &&
//       setOpen(false);

//     document.addEventListener("mousedown", close);
//     return () => document.removeEventListener("mousedown", close);
//   }, []);

//   const handleLogout = () => {
//     dispatch(logout());
//     window.location.href = "/";
//   };

//   const handleHome = () => {
//     if (role === "MERCHANT") navigate("/retailerdashboard");
//     if (role === "DISTRIBUTOR") navigate("/distributordashboard");
//     if (role === "MASTER_DISTRIBUTOR") navigate("/masterdistributordashboard");
//   };

//   const handleRefreshBalance = () => {
//     dispatch(fetchWalletBalance());
//     dispatch(fetchAepsBalance());
//     // dispatch(fetchLienBalance());
//     dispatch(fetchSettlementBalance());
//   };

//   // Helper function to keep your JSX clean
//   const displayAmount = (amount) => {
//     if (loading) return "…";
//     if (!showBalance) return "••••••"; // Hidden state
//     return Number(amount || 0).toFixed(2);
//   };

//   return (
//     <header className="fixed top-0 left-0 w-full h-16 z-50 flex">

//       {/* ===== LEFT LOGO ===== */}
//       <div className="hidden md:flex w-[240px] bg-white items-center justify-center shadow-sm border-r border-slate-200">
//         <div onClick={handleHome} className="cursor-pointer">
//           <img
//             src={bingopayLogo}
//             alt="logo"
//             className="h-10 object-contain"
//           />
//         </div>
//       </div>

//       {/* ===== RIGHT NAVBAR ===== */}
//       <div className="flex-1 bg-[#0A2A4F] flex items-center justify-between px-4 md:px-6">

//         {/* ===== LEFT (MENU) ===== */}
//         <div className="flex items-center gap-3 text-white">
//           <button
//             onClick={() => dispatch(toggle())}
//             className="p-2 rounded-lg bg-white text-[#0A2A4F] hover:bg-[#0A2A4F] hover:text-white active:bg-[#0A2A4F] active:text-white transition-all duration-200"
//           >
//             <Menu size={18} />
//           </button>
//         </div>

//         {/* ===== RIGHT (BALANCE + ACTIONS) ===== */}
//         <div className="flex items-center gap-6 text-white">

//           {/* ===== SUBSCRIPTION BUTTON ===== */}
//           {/* {role === "MERCHANT" && (
//             <button
//               onClick={() => navigate("/subscription")}
//               className="relative overflow-hidden px-4 py-2 rounded-full bg-gradient-to-r from-[#12345A] to-[#1E4D8C] text-white font-semibold text-sm shadow-md hover:shadow-xl hover:scale-105 active:scale-95 transition-all duration-300 flex items-center gap-2 border border-yellow-400/40"
//             >
            
//               <span className="absolute inset-0 bg-gradient-to-r from-yellow-400/10 to-transparent pointer-events-none" />

//               <span className="w-6 h-6 rounded-full bg-yellow-400 text-[#12345A] flex items-center justify-center text-xs font-bold shadow">
//                 ₹
//               </span>

//               <span className="relative z-10">
//                 Subscription
//               </span>
//             </button>
//           )} */}

//           {/* ===== BALANCE (EYE TOGGLE) ===== */}
//           <div className="hidden md:flex items-center gap-6">
//             <div className="text-right">
//               <p className="text-xs font-medium uppercase tracking-wide text-blue-200">
//                 Main
//               </p>
//               <p className="text-[28px] font-black leading-none text-cyan-300">
//                 ₹ {displayAmount(balance)}
//               </p>
//             </div>

//             <div className="text-right">
//               <p className="text-xs font-medium uppercase tracking-wide text-emerald-200">
//                 AEPS
//               </p>
//               <p className="text-[28px] font-black leading-none text-emerald-400">
//                 ₹ {displayAmount(aepsBalance)}
//               </p>
//             </div>

//             <div className="text-right">
//               <p className="text-xs font-medium uppercase tracking-wide text-amber-200">
//                 Comm
//               </p>
//               <p className="text-[28px] font-black leading-none text-amber-400">
//                 ₹ {displayAmount(settlementBalance)}
//               </p>
//             </div>

//             {/* Toggle Button */}
//             <button
//               onClick={() => {
//                 if (!showBalance) {
//                   handleRefreshBalance();
//                 }
//                 setShowBalance(!showBalance);
//               }}
//               className="ml-2 p-2 rounded-full hover:bg-white/10 transition-colors text-white/90 hover:text-white"
//               title={showBalance ? "Hide Balances" : "Show Balances"}
//             >
//               {showBalance ? <FiEyeOff size={20} /> : <FiEye size={20} />}
//             </button>
//           </div>

//           {/* ===== PROFILE ===== */}
//           <div className="relative" ref={dropdownRef}>
//             <button
//               onClick={() => setOpen(!open)}
//               className="flex items-center gap-2 bg-white text-[#0A2A4F] px-2.5 py-1.5 rounded-lg hover:bg-[#E6EEF8] hover:text-[#0A2A4F] transition-all duration-300"
//             >
//               <div className="w-8 h-8 rounded-full bg-[#0A2A4F] flex items-center justify-center text-white text-sm font-semibold">
//                 {username?.[0]?.toUpperCase() || "U"}
//               </div>

//               <ChevronDown size={14} />
//             </button>

//             {open && (
//               <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-slate-200">
//                 <button
//                   onClick={() => {
//                     navigate("/profile");
//                     setOpen(false);
//                   }}
//                   className="w-full px-4 py-2 text-sm text-[#0A2A4F] hover:bg-slate-100 flex items-center gap-2"
//                 >
//                   <User2 size={14} /> Profile
//                 </button>

//                 <button
//                   onClick={handleLogout}
//                   className="w-full px-4 py-2 text-sm text-red-600 hover:bg-red-50 flex items-center gap-2"
//                 >
//                   <LogOut size={14} /> Logout
//                 </button>
//               </div>
//             )}
//           </div>

//         </div>
//       </div>
//     </header>
//   );
// };

// export default Navbar;





// import React, { useState, useRef, useEffect } from "react";
// import { 
//   Menu, 
//   ChevronDown, 
//   LogOut, 
//   User2, 
//   Eye, 
//   EyeOff, 
//   RefreshCw, 
//   Wallet,
//   Building2,
//   Percent
// } from "lucide-react";
// import { useNavigate } from "react-router-dom";
// import { useDispatch, useSelector } from "react-redux";
// import { logout, toggle } from "../Store/Slices/AuthSlice";
// import bingopayLogo from "../Assets/Images/logo_png_with_shreebalajee (1).png";
// import {
//   fetchWalletBalance,
//   fetchAepsBalance,
//   fetchLienBalance,
//   fetchSettlementBalance,
// } from "../Store/Slices/WalletSlice";

// const Navbar = () => {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const dropdownRef = useRef(null);

//   const [open, setOpen] = useState(false);
//   const [showBalance, setShowBalance] = useState(true);
//   const [isRefreshing, setIsRefreshing] = useState(false);

//   const role = useSelector((s) => s.auth.employeeDetails?.role);
//   const username = useSelector((s) => s.auth.employeeDetails?.username);
//   const { merchant_shop_name } =
//       useSelector((s) => s.auth.employeeDetails?.others) || {};
  

//   const { balance, aepsBalance, loading, settlementBalance } = useSelector(
//     (s) => s.wallet
//   );

//   // ===== INITIAL SIDEBAR STATE =====
//   useEffect(() => {
//     if (window.innerWidth >= 768) {
//       dispatch(toggle(true)); // desktop open
//     } else {
//       dispatch(toggle(false)); // mobile close
//     }
//   }, [dispatch]);

//   // ===== FETCH BALANCE =====
//   useEffect(() => {
//     dispatch(fetchWalletBalance());
//     dispatch(fetchAepsBalance());
//     dispatch(fetchSettlementBalance());
//   }, [dispatch]);

//   // ===== CLOSE DROPDOWN =====
//   useEffect(() => {
//     const close = (e) =>
//       dropdownRef.current &&
//       !dropdownRef.current.contains(e.target) &&
//       setOpen(false);

//     document.addEventListener("mousedown", close);
//     return () => document.removeEventListener("mousedown", close);
//   }, []);

//   const handleLogout = () => {
//     dispatch(logout());
//     window.location.href = "/";
//   };

//   const handleHome = () => {
//     if (role === "MERCHANT") navigate("/retailerdashboard");
//     if (role === "DISTRIBUTOR") navigate("/distributordashboard");
//     if (role === "MASTER_DISTRIBUTOR") navigate("/masterdistributordashboard");
//   };

//   const handleRefreshBalance = async () => {
//     setIsRefreshing(true);
//     dispatch(fetchWalletBalance());
//     dispatch(fetchAepsBalance());
//     dispatch(fetchSettlementBalance());
//     setTimeout(() => setIsRefreshing(false), 500);
//   };

//   const displayAmount = (amount) => {
//     if (loading) return "…";
//     if (!showBalance) return "••••••";
//     return Number(amount || 0).toLocaleString("en-IN", {
//       minimumFractionDigits: 2,
//       maximumFractionDigits: 2,
//     });
//   };

//   return (
//     <header className="fixed top-0 left-0 w-full h-16 z-50 flex shadow-sm">
//       {/* ===== LEFT LOGO AREA ===== */}
//       <div className="hidden md:flex w-[240px] bg-white items-center justify-center border-r border-slate-200/80 px-4 transition-all">
//         <div 
//           onClick={handleHome} 
//           className="cursor-pointer hover:opacity-90 transition active:scale-95"
//         >
//           <img
//             src={bingopayLogo}
//             alt="BingoPay Logo"
//             className="h-9 object-contain"
//           />
//         </div>
//       </div>

//       {/* ===== RIGHT NAVBAR AREA ===== */}
//       <div className="flex-1 bg-gradient-to-r from-[#0A2540] via-[#0F3057] to-[#123E6B] flex items-center justify-between px-3 sm:px-6">
        
//         {/* ===== TOGGLE SIDEBAR BUTTON ===== */}
//         <div className="flex items-center gap-3">
//           <button
//             onClick={() => dispatch(toggle())}
//             className="p-2 rounded-xl bg-white/10 hover:bg-white/20 text-white transition active:scale-95 backdrop-blur-xs border border-white/10"
//             title="Toggle Sidebar"
//           >
//             <Menu size={18} />
//           </button>
//         </div>

//         {/* ===== RIGHT CONTROLS (BALANCES & USER PROFILE) ===== */}
//         <div className="flex items-center gap-3 sm:gap-5">

//           {/* ===== COMPACT BALANCES PILLS (DESKTOP) ===== */}
//           <div className="hidden lg:flex items-center gap-2.5">
//             {/* Main Balance Pill */}
//             <div className="flex items-center gap-2.5 px-5 py-1.5 rounded-xl bg-white/10 border border-white/10 backdrop-blur-md">
//               <div className="p-1 rounded-lg bg-sky-500/20 text-sky-300">
//                 <Wallet size={14} />
//               </div>
//               <div className="leading-tight">
//                 <p className="text-[9px] font-bold uppercase tracking-wider text-slate-300">Main</p>
//                 <p className="text-xs font-bold text-white tracking-tight">₹ {displayAmount(balance)}</p>
//               </div>
//             </div>

//             {/* AEPS Balance Pill */}
//             <div className="flex items-center gap-2.5 px-5 py-1.5 rounded-xl bg-white/10 border border-white/10 backdrop-blur-md">
//               <div className="p-1 rounded-lg bg-emerald-500/20 text-emerald-300">
//                 <Building2 size={14} />
//               </div>
//               <div className="leading-tight">
//                 <p className="text-[9px] font-bold uppercase tracking-wider text-slate-300">AEPS</p>
//                 <p className="text-xs font-bold text-emerald-300 tracking-tight">₹ {displayAmount(aepsBalance)}</p>
//               </div>
//             </div>

//             {/* Commission Balance Pill */}
//             <div className="flex items-center gap-2.5 px-5 py-1.5 rounded-xl bg-white/10 border border-white/10 backdrop-blur-md">
//               <div className="p-1 rounded-lg bg-amber-500/20 text-amber-300">
//                 <Percent size={14} />
//               </div>
//               <div className="leading-tight">
//                 <p className="text-[9px] font-bold uppercase tracking-wider text-slate-300">Comm</p>
//                 <p className="text-xs font-bold text-amber-300 tracking-tight">₹ {displayAmount(settlementBalance)}</p>
//               </div>
//             </div>

//             {/* Sync & Visibility Actions */}
//             <div className="flex items-center gap-1 pl-1">
//               <button
//                 onClick={handleRefreshBalance}
//                 disabled={isRefreshing}
//                 className="p-1.5 rounded-lg text-slate-300 hover:text-white hover:bg-white/10 transition active:scale-95"
//                 title="Refresh Balances"
//               >
//                 <RefreshCw size={15} className={isRefreshing ? "animate-spin text-sky-400" : ""} />
//               </button>

//               <button
//                 onClick={() => {
//                   if (!showBalance) handleRefreshBalance();
//                   setShowBalance(!showBalance);
//                 }}
//                 className="p-1.5 rounded-lg text-slate-300 hover:text-white hover:bg-white/10 transition active:scale-95"
//                 title={showBalance ? "Hide Balances" : "Show Balances"}
//               >
//                 {showBalance ? <EyeOff size={15} /> : <Eye size={15} />}
//               </button>
//             </div>
//           </div>

//           {/* Divider */}
//           <div className="hidden lg:block h-6 w-px bg-white/15" />

//           {/* ===== USER PROFILE DROPDOWN ===== */}
//           <div className="relative" ref={dropdownRef}>
//             <button
//               onClick={() => setOpen(!open)}
//               className="flex items-center gap-2.5 p-1.5 sm:px-3 sm:py-1.5 rounded-xl bg-white/10 hover:bg-white/15 border border-white/10 text-white transition active:scale-95 backdrop-blur-xs"
//             >
//               <div className="w-7 h-7 rounded-lg bg-gradient-to-tr from-sky-400 to-blue-600 flex items-center justify-center text-white text-xs font-bold shadow-xs">
//                 {merchant_shop_name?.[0]?.toUpperCase() || "U"}
//               </div>

//               <div className="hidden sm:block text-left leading-tight">
//                 <p className="text-xs font-semibold text-white truncate max-w-[110px]">
//                   {merchant_shop_name || "User"}
//                 </p>
//                 <p className="text-[10px] text-blue-200 font-medium capitalize">
//                   {role ? role.toLowerCase().replace("_", " ") : "Partner"}
//                 </p>
//               </div>

//               <ChevronDown 
//                 size={14} 
//                 className={`text-slate-300 transition-transform duration-200 ${open ? "rotate-180" : ""}`} 
//               />
//             </button>

//             {/* Dropdown Menu */}
//             {open && (
//               <div className="absolute right-0 mt-2.5 w-52 bg-white rounded-2xl shadow-xl border border-slate-100 p-1.5 z-50 animate-in fade-in slide-in-from-top-2 duration-150">
//                 <div className="px-3 py-2 border-b border-slate-100 mb-1">
//                   <p className="text-xs font-bold text-slate-800">{merchant_shop_name}</p>
//                   <p className="text-[10px] text-slate-400 font-medium capitalize">{role || "Retailer"}</p>
//                 </div>

//                 <button
//                   onClick={() => {
//                     navigate("/profile");
//                     setOpen(false);
//                   }}
//                   className="w-full px-3 py-2 text-xs font-medium text-slate-700 hover:bg-slate-50 hover:text-blue-600 rounded-xl flex items-center gap-2.5 transition"
//                 >
//                   <User2 size={15} className="text-slate-400" />
//                   <span>My Profile</span>
//                 </button>

//                 <button
//                   onClick={handleLogout}
//                   className="w-full px-3 py-2 text-xs font-medium text-rose-600 hover:bg-rose-50 rounded-xl flex items-center gap-2.5 transition mt-0.5"
//                 >
//                   <LogOut size={15} className="text-rose-500" />
//                   <span>Sign Out</span>
//                 </button>
//               </div>
//             )}
//           </div>

//         </div>
//       </div>
//     </header>
//   );
// };

// export default Navbar;




import React, { useState, useRef, useEffect } from "react";
import { 
  Menu, 
  ChevronDown, 
  LogOut, 
  User2, 
  Eye, 
  EyeOff, 
  RefreshCw, 
  Wallet,
  Building2,
  Percent
} from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logout, toggle } from "../Store/Slices/AuthSlice";
import { logoutFromGateway } from "../CustomHooks/gatewayLogout";

import bingopayLogo from "../Assets/Images/logo_png_with_shreebalajee (1).png";
import {
  fetchWalletBalance,
  fetchAepsBalance,
  fetchLienBalance,
  fetchSettlementBalance,
} from "../Store/Slices/WalletSlice";

// ================= REUSABLE BALANCE PILL COMPONENT =================
const BalancePill = ({ label, amount, icon: Icon, iconBgClass, valueColorClass }) => {
  return (
    <div className="flex items-center gap-2.5 px-5 py-1.5 rounded-xl bg-white/10 border border-white/10 backdrop-blur-md">
      <div className={`p-1 rounded-lg ${iconBgClass}`}>
        <Icon size={14} />
      </div>
      <div className="leading-tight">
        <p className="text-[13px] font-bold uppercase tracking-wider text-slate-300">
          {label}
        </p>
        <p className={`text-[17px] font-bold tracking-tight ${valueColorClass}`}>
          ₹ {amount}
        </p>
      </div>
    </div>
  );
};

const Navbar = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const dropdownRef = useRef(null);

  const [open, setOpen] = useState(false);
  const [showBalance, setShowBalance] = useState(true);
  const [isRefreshing, setIsRefreshing] = useState(false);

  const role = useSelector((s) => s.auth.employeeDetails?.role);
  const username = useSelector((s) => s.auth.employeeDetails?.username);
  const { merchant_shop_name } =
    useSelector((s) => s.auth.employeeDetails?.others) || {};

  const { balance, aepsBalance, loading, settlementBalance } = useSelector(
    (s) => s.wallet
  );

  // ===== INITIAL SIDEBAR STATE =====
  useEffect(() => {
    if (window.innerWidth >= 768) {
      dispatch(toggle(true));
    } else {
      dispatch(toggle(false));
    }
  }, [dispatch]);

  // ===== FETCH BALANCE =====
  useEffect(() => {
    dispatch(fetchWalletBalance());
    dispatch(fetchAepsBalance());
    dispatch(fetchSettlementBalance());
  }, [dispatch]);

  // ===== CLOSE DROPDOWN =====
  useEffect(() => {
    const close = (e) =>
      dropdownRef.current &&
      !dropdownRef.current.contains(e.target) &&
      setOpen(false);

    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, []);

  const handleLogout = async () => {
    await logoutFromGateway();       // frees this login's slot at the gateway (best effort, short wait)
    dispatch(logout());
    window.location.href = "/";
  };

  const handleHome = () => {
    if (role === "MERCHANT") navigate("/retailerdashboard");
    if (role === "DISTRIBUTOR") navigate("/distributordashboard");
    if (role === "MASTER_DISTRIBUTOR") navigate("/masterdistributordashboard");
  };

  const handleRefreshBalance = async () => {
    setIsRefreshing(true);
    dispatch(fetchWalletBalance());
    dispatch(fetchAepsBalance());
    dispatch(fetchSettlementBalance());
    setTimeout(() => setIsRefreshing(false), 500);
  };

  const displayAmount = (amount) => {
    if (loading) return "…";
    if (!showBalance) return "••••••";
    return Number(amount || 0).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  return (
    <header className="fixed top-0 left-0 w-full h-16 z-50 flex shadow-sm">
      {/* ===== LEFT LOGO AREA ===== */}
      {/* <div 
        onClick={handleHome} 
        className="hidden md:flex w-[240px] h-16 bg-[#0A2540] items-center px-5 border-r border-white/10 cursor-pointer select-none group transition-all"
      >
        <div className="flex items-center gap-2.5">
          <div className="w-8 h-8 rounded-xl bg-gradient-to-tr from-amber-400 via-yellow-500 to-amber-600 flex items-center justify-center shadow-md shadow-amber-500/20 group-hover:scale-105 transition-transform duration-200">
            <span className="text-[#0A2540] font-black text-base tracking-tighter">
              B
            </span>
          </div>

          <div className="flex flex-col leading-none">
            <div className="text-lg font-black tracking-tight flex items-center">
              <span className="text-white group-hover:text-blue-100 transition-colors">
                BINGO
              </span>
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-300 via-amber-400 to-yellow-500 ml-1 drop-shadow-xs">
                PAY
              </span>
            </div>
            <span className="text-[8px] uppercase tracking-wider text-slate-400 font-semibold mt-0.5">
              Shree Balajee Connect
            </span>
          </div>
        </div>
      </div> */}

      <div className="hidden md:flex w-[240px] bg-white items-center justify-center border-r border-slate-200/80 px-4 transition-all">
        <div 
          onClick={handleHome} 
          className="cursor-pointer hover:opacity-90 transition active:scale-95"
        >
          <img
            src={bingopayLogo}
            alt="BingoPay Logo"
            className="h-9 object-contain"
          />
        </div>
      </div>

      {/* ===== RIGHT NAVBAR AREA ===== */}
      <div className="flex-1 bg-gradient-to-r from-[#0A2540] via-[#0F3057] to-[#123E6B] flex items-center justify-between px-3 sm:px-6">
        
        {/* ===== TOGGLE SIDEBAR BUTTON ===== */}
        <div className="flex items-center gap-3">
          <button
            onClick={() => dispatch(toggle())}
            className="p-2 rounded-xl bg-white/10 hover:bg-white/20 text-white transition active:scale-95 backdrop-blur-xs border border-white/10"
            title="Toggle Sidebar"
          >
            <Menu size={18} />
          </button>
        </div>

        {/* ===== RIGHT CONTROLS (BALANCES & USER PROFILE) ===== */}
        <div className="flex items-center gap-3 sm:gap-5">

          {/* ===== COMPACT BALANCES PILLS (DESKTOP) ===== */}
          <div className="hidden lg:flex items-center gap-2.5">
            {/* Main Balance */}
            <BalancePill
              label="Main"
              amount={displayAmount(balance)}
              icon={Wallet}
              iconBgClass="bg-sky-500/20 text-sky-300"
              valueColorClass="text-white"
            />

            {/* AEPS Balance */}
            {!(username === "sou4276_2330" && role === "MERCHANT") && (
              <BalancePill
                label="AEPS"
                amount={displayAmount(aepsBalance)}
                icon={Building2}
                iconBgClass="bg-emerald-500/20 text-emerald-300"
                valueColorClass="text-emerald-300"
              />
            )}

            {/* Commission Balance */}
            <BalancePill
              label="Comm"
              amount={displayAmount(settlementBalance)}
              icon={Percent}
              iconBgClass="bg-amber-500/20 text-amber-300"
              valueColorClass="text-amber-300"
            />

            {/* Sync & Visibility Actions */}
            <div className="flex items-center gap-1 pl-1">
              <button
                onClick={handleRefreshBalance}
                disabled={isRefreshing}
                className="p-1.5 rounded-lg text-slate-300 hover:text-white hover:bg-white/10 transition active:scale-95"
                title="Refresh Balances"
              >
                <RefreshCw size={20} className={isRefreshing ? "animate-spin text-sky-400" : ""} />
              </button>

              <button
                onClick={() => {
                  if (!showBalance) handleRefreshBalance();
                  setShowBalance(!showBalance);
                }}
                className="p-1.5 rounded-lg text-slate-300 hover:text-white hover:bg-white/10 transition active:scale-95"
                title={showBalance ? "Hide Balances" : "Show Balances"}
              >
                {showBalance ? <EyeOff size={20} /> : <Eye size={20} />}
              </button>
            </div>
          </div>

          {/* Divider */}
          <div className="hidden lg:block h-6 w-px bg-white/15" />

          {/* ===== USER PROFILE DROPDOWN ===== */}
          <div className="relative" ref={dropdownRef}>
            <button
              onClick={() => setOpen(!open)}
              className="flex items-center gap-2.5 p-1.5 sm:px-3 sm:py-1.5 rounded-xl bg-white/10 hover:bg-white/15 border border-white/10 text-white transition active:scale-95 backdrop-blur-xs"
            >
              <div className="w-7 h-7 rounded-lg bg-gradient-to-tr from-sky-400 to-blue-600 flex items-center justify-center text-white text-xs font-bold shadow-xs">
                {merchant_shop_name?.[0]?.toUpperCase() || "U"}
              </div>

              <div className="hidden sm:block text-left leading-tight">
                <p className="text-xs font-semibold text-white truncate max-w-[110px]">
                  {merchant_shop_name || "User"}
                </p>
                <p className="text-[10px] text-blue-200 font-medium capitalize">
                  {role ? role.toLowerCase().replace("_", " ") : "Partner"}
                </p>
              </div>

              <ChevronDown 
                size={14} 
                className={`text-slate-300 transition-transform duration-200 ${open ? "rotate-180" : ""}`} 
              />
            </button>

            {/* Dropdown Menu */}
            {open && (
              <div className="absolute right-0 mt-2.5 w-52 bg-white rounded-2xl shadow-xl border border-slate-100 p-1.5 z-50 animate-in fade-in slide-in-from-top-2 duration-150">
                <div className="px-3 py-2 border-b border-slate-100 mb-1">
                  <p className="text-xs font-bold text-slate-800">{merchant_shop_name}</p>
                  <p className="text-[10px] text-slate-400 font-medium capitalize">{role || "Retailer"}</p>
                </div>

                <button
                  onClick={() => {
                    navigate("/profile");
                    setOpen(false);
                  }}
                  className="w-full px-3 py-2 text-xs font-medium text-slate-700 hover:bg-slate-50 hover:text-blue-600 rounded-xl flex items-center gap-2.5 transition"
                >
                  <User2 size={15} className="text-slate-400" />
                  <span>My Profile</span>
                </button>

                <button
                  onClick={handleLogout}
                  className="w-full px-3 py-2 text-xs font-medium text-rose-600 hover:bg-rose-50 rounded-xl flex items-center gap-2.5 transition mt-0.5"
                >
                  <LogOut size={15} className="text-rose-500" />
                  <span>Sign Out</span>
                </button>
              </div>
            )}
          </div>

        </div>
      </div>
    </header>
  );
};

export default Navbar;